export var PaymentOption;
(function (PaymentOption) {
    PaymentOption["ALL"] = "ALL";
    PaymentOption["DUE_THIS_WEEK"] = "DUE_THIS_WEEK";
    PaymentOption["SELECT_INVOICES"] = "SELECT_INVOICES";
    PaymentOption["CUSTOM"] = "CUSTOM";
})(PaymentOption || (PaymentOption = {}));
